import {
  Document, Paragraph, Packer, TextRun, HeadingLevel,
} from 'docx';

export function exportDocx() {
  let speaker = '';
  const hypertranscript = document.getElementById('hypertranscript');
  const regex = /[\[\]]/g;
  const title = document.getElementById('title').innerText;
  // Transform dom to array of strings
  const children = Array.from(hypertranscript.firstElementChild.firstElementChild.children);
  const stringArray = [{ speaker: '', text: '' }];
  children.map((paragraph) => {
    if (paragraph.firstElementChild) {
      // new paragraph
      if (paragraph.firstElementChild.classList.contains('speaker') && paragraph.firstElementChild.innerHTML != speaker) {
        speaker = paragraph.firstElementChild.innerHTML;
        let paragraphString = '';
        // Slice removes dublicate speaker name
        Array.from(paragraph.childNodes).slice(1).map((word) => {
          const data = word.childNodes?.[0]?.data ?? '';
          if (data.startsWith(' ')) {
            paragraphString += data;
          } else {
            paragraphString += ` ${data}`;
          }
        });
        stringArray.push({
          speaker: speaker.replaceAll(regex, ''),
          text: paragraphString,
        });
      } else {
        // same paragraph
        // Slice removes dublicate speaker name
        const array = paragraph.childNodes[0].classList.contains('speaker') ? Array.from(paragraph.childNodes).slice(1) : Array.from(paragraph.childNodes);
        array.map((word) => {
          const data = word.childNodes?.[0]?.data ?? '';
          if (data.startsWith(' ')) {
            stringArray[stringArray.length - 1].text += data;
          } else {
            stringArray[stringArray.length - 1].text += ` ${data}`;
          }
        });
      }
    }
  });
  stringArray.map((each) => {
    console.log(each.speaker, each.text);
  });

  // Creating array of docx elements with heading
  const textArray = [new Paragraph({
    text: title,
    heading: HeadingLevel.HEADING_2,
    spacing: {
      after: 200,
    },
  })];

  // Fill array with docx elements
  stringArray.map((each) => {
    textArray.push(
      new Paragraph({
        children: [
          new TextRun({
            text: each.speaker,
            bold: true,
            size: 16,
          }),
          new TextRun(each.text),
        ],
        spacing: {
          before: 200,
          after: 200,
        },
      }),
    );
  });

  // Create docx file
  const doc = new Document({
    creator: 'ILSP transcript editor',
    title,
    sections: [
      {
        properties: {},
        children: textArray,
      },
    ],
  });

  // Download .docx file
  Packer.toBlob(doc).then((blob) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, `${title}.docx`);
    } else {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `${title}.docx`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  });
}
